export enum ProjectorDimensions {
  width = <any>'width',
  height = <any>'height',
  diagonal = <any>'diagonal'
}
